import * as React from "react";

const ArrowUpward: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
            <rect width="100%" height="100%" fill="none" />
            <g>
                <path
                    fill="currentColor"
                    d="M13 19V7.14l4.36 3.63a1.001 1.001 0 0 0 1.28-1.54l-6-5a1.19 1.19 0 0 0-.15-.09c-.05 0-.08 0-.13-.07A1 1 0 0 0 12 4a1 1 0 0 0-.36.07c-.05 0-.08 0-.13.07a1.145 1.145 0 0 0-.15.09l-6 5A1 1 0 0 0 5 10a1 1 0 0 0 1.64.77L11 7.14V19a1 1 0 1 0 2 0z"
                />
            </g>
        </svg>
    );
};

export default React.memo(ArrowUpward);
